export enum LogoTypes {
    black = 'black',
    white = 'white'
}